/**
 * shared/protocol/ids.ts — binary message type ids (first u8 of every binary frame) [NET §6].
 * Text frames are JSON control messages (control.ts). Little-endian everywhere.
 * OWNER: integration (contract); netcode agent may append ids via CONTRACT-REQUESTS.
 */
export const MsgType = {
  /** client -> server: usercmd packet (ackSnapTick, firstCmdNumber, count, cmds[]) [NET §6.1]. */
  CMD: 0x01,
  /** client -> server: desync debug (predicted origin + cmd number), optional. */
  CMD_DEBUG: 0x02,
  /** server -> client: snapshot [NET §6.2]. */
  SNAP: 0x81,
} as const;
export type MsgType = (typeof MsgType)[keyof typeof MsgType];
